import clientApi from '~/clientApi';
import { YoutubeInsightType, YoutubeType } from '~/types';

export const getYoutubeContents = async (
  contentIds = [] as string[],
  sharedToken?: string,
  creatorId?: string,
): Promise<YoutubeType[]> => {
  return Promise.all(
    (contentIds || []).map((id) =>
      clientApi.ytContent.read({
        id,
        _sharedToken: sharedToken,
        _impersonateOnce: creatorId,
      }),
    ),
  );
};

export const getYoutubeInsights = (
  mediaPackId: string,
  sharedToken?: string,
  creatorId?: string,
): Promise<YoutubeInsightType> =>
  clientApi.mediaPacks.ytInsights({
    id: mediaPackId,
    _sharedToken: sharedToken,
    _impersonateOnce: creatorId,
  });
